/**
 * Every server code meaning "this invitation is no longer a decision you can make".
 *
 * <p>Mirrors `ValidationErrorCodes.INVITATION_NO_LONGER_PENDING` / `INVITATION_REVOKED` /
 * `INVITATION_ALREADY_RESOLVED`. Branching on the code rather than on the message is the whole point:
 * the message arrives already localized, so matching its text would work in English and silently stop
 * working in the other 24 locales.
 *
 * <p>The generic code stays in the set and stays FIRST. It is what a server deployed before the
 * 2026-08-24 split still sends, and the two halves of a deploy do not land at the same instant.
 *
 * <p>Every caller does the same thing with all three: drop the affordance, and show the server's own
 * localized text as information rather than as a failure. What differs is only what the member READS,
 * and the server owns that — a withdrawn invitation says something different from one already answered.
 *
 * <p><b>Its own module, deliberately.</b> It lived on `GroupGovernanceApi` for one commit and every
 * suite that stubs that module (a network module, so several do) lost the predicate and threw. A pure
 * constant has no reason to sit behind a mock boundary.
 *
 * Design:
 * `designs/01-now/2026-08-24-group-invitation-accept-idempotency-and-stale-decision-row-design.md`.
 */
export const INVITATION_NO_LONGER_ACTIONABLE_ERROR_CODES: readonly string[] = [
    "INVITATION_NO_LONGER_PENDING",
    "INVITATION_REVOKED",
    "INVITATION_ALREADY_RESOLVED",
];

export function isInvitationNoLongerActionableCode(code: string | null | undefined): boolean {
    return code != null && INVITATION_NO_LONGER_ACTIONABLE_ERROR_CODES.includes(code);
}
